import React, { useState, useEffect } from 'react';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import Verified from '../../../images/icons/tickOk.svg';
import RentalAgreement from './RentalAgreement';
import RelationShip from './RelationShip';
import { GETAPI } from '../../../common/constants/api';
import PopUp from '../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';

const ResidentialStatus = props => {
  const {
    values,
    data,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched
  } = props;

  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('loading...');
  const [show, setShow] = useState(false);
  const [ispreviousData, setispreviousData] = useState('');
  const setData = async data => {
    if (data?.links[0]) {
      await setFieldValue('showPreviousImage', data.links[0].url);
    }

    if (data?.userData) {
      let neededDetails = data.userData;
      neededDetails?.isOwned
        ? setFieldValue('PropertyType', 'owned')
        : setFieldValue('PropertyType', 'rented');
      neededDetails?.isOwned
        ? setFieldValue('OwnedBy', neededDetails?.ownedBy)
        : setFieldValue('OwnedBy', false);
      setFieldValue('monthlyRent', parseInt(neededDetails?.rentPerMonth));

      setFieldValue('firstName', neededDetails?.name?.firstName || '');
      setFieldValue('middleName', neededDetails?.name?.middleName || '');
      setFieldValue('lastName', neededDetails?.name?.lastName || '');
      setFieldValue(
        'relationShip',
        {
          label: neededDetails?.relation
            ? neededDetails?.relation
            : 'Relationship',
          value: neededDetails?.relation ? neededDetails?.relation : ''
        } || ''
      );
    }
  };

  useEffect(() => {
    const getExcistedData = async () => {
      await setPopUpText('Loading...');
      await setPopUpType('loading');
      setShow(true);
      GETAPI(leadId, applicantId, 'residency')
        .then(res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }
          setData(res);
          setShow(false);
        })
        .catch(err => {});
    };

    getExcistedData();
  }, []);

  return (
    <div className="w-full  bg-blue-1210 md:bg-white">
      <div className="w-full  px-5 md:px-10 my-3 md:my-10">
        <p className="font-roboto font-medium text-black-1002 text-base">
          Residence Status
        </p>
        <div className="w-full md:flex block py-3">
          <div className="flex-row-reverse flex md:flex-row  py-2 md:py-0">
            <RadioButton
              name="PropertyType"
              checked={values.PropertyType == 'owned' ? true : false}
              onChange={e => {
                handleChange(e), setFieldValue('PropertyType', 'owned');
              }}
              onBlur={handleBlur}
            />
            <p className="font-roboto font-normal text-grey-2000 md:px-2 mr-auto">
              Owned
            </p>
          </div>
          <div className="mr-auto flex md:ml-10 flex-row-reverse md:flex-row py-2 md:py-0">
            <RadioButton
              name="PropertyType"
              checked={values.PropertyType == 'rented' ? true : false}
              onChange={e => {
                handleChange(e), setFieldValue('PropertyType', 'rented');
              }}
              onBlur={handleBlur}
            />
            <p className="font-roboto font-normal text-grey-2000 md:px-3 mr-auto">
              Rented
            </p>
          </div>
        </div>
      </div>

      {values.PropertyType == 'owned' ? (
        <div className="w-full  px-5 md:px-10 my-3 md:my-10">
          <p className="font-roboto font-medium text-black-1002 text-base">
            Residence Owned by
          </p>
          <div className="w-full md:flex block py-3">
            <div className="flex-row-reverse flex md:flex-row py-2 md:py-0">
              <RadioButton
                name="OwnedBy"
                checked={values.OwnedBy == 'parent' ? true : false}
                onChange={e => {
                  handleChange(e), setFieldValue('OwnedBy', 'parent');
                }}
                onBlur={handleBlur}
              />
              <p className="font-roboto font-normal text-grey-2000 md:px-2 mr-auto">
                Parent
              </p>
            </div>
            <div className="flex md:ml-10 flex-row-reverse md:flex-row py-2 md:py-0">
              <RadioButton
                name="OwnedBy"
                checked={values.OwnedBy == 'self' ? true : false}
                onChange={e => {
                  handleChange(e), setFieldValue('OwnedBy', 'self');
                }}
                onBlur={handleBlur}
              />
              <p className="font-roboto font-normal text-grey-2000 md:px-2  mr-auto">
                Self
              </p>
            </div>
            <div className="mr-auto flex md:ml-10 flex-row-reverse md:flex-row py-2 md:py-0">
              <RadioButton
                name="OwnedBy"
                checked={values.OwnedBy == 'family' ? true : false}
                onChange={e => {
                  handleChange(e), setFieldValue('OwnedBy', 'family');
                }}
                onBlur={handleBlur}
              />
              <p className="font-roboto font-normal text-grey-2000 md:px-2 mr-auto">
                Other Family Member
              </p>
            </div>
          </div>

          {(values.OwnedBy == 'parent' || values.OwnedBy == 'family') && (
            <RelationShip
              values={values}
              data={data}
              handleChange={handleChange}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
            />
          )}
        </div>
      ) : values.PropertyType == 'rented' ? (
        <RentalAgreement
          values={values}
          data={data}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
        />
      ) : null}
      <PopUp type={popUpType} text={popUpText} setShow={setShow} show={show} />
    </div>
  );
};

export default ResidentialStatus;
